import { render, staticRenderFns } from "./ExpressOrderEdit.vue?vue&type=template&id=3bf1bf90&scoped=true&"
import script from "./ExpressOrderEdit.vue?vue&type=script&lang=js&"
export * from "./ExpressOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf1bf90",
  null
  
)

export default component.exports